export function Demo() {
	return (
		<section id="demo" style={{ padding: '120px 0', background: 'var(--mist)' }}>
			<div className="mx-auto max-w-310 px-5 md:px-10">
				<div className="mx-auto mb-16 max-w-160 text-center">
					<div className="eyebrow mb-6 justify-center">Démonstration</div>
					<h2 className="pb-5">
						Une alerte,{' '}
						<span className="serif-italic">construite en 30 secondes</span>.
					</h2>
					<p
						style={{
							fontSize: 17,
							color: 'var(--text-secondary)',
							lineHeight: 1.6,
						}}
					>
						Pas de configuration complexe. Décrivez ce que vous surveillez,
						choisissez votre fréquence, et Vigilio s'occupe du reste.
					</p>
				</div>

				<div className="grid items-center gap-12 md:grid-cols-[1fr_1.2fr] md:gap-20">
					<ul className="flex flex-col gap-3.5">
						{[
							'Opérateurs booléens : ET, OU, SAUF',
							'Filtrage par source, région, date',
							'Tests en direct avant activation',
							'Exports CSV et intégrations API',
						].map((item) => (
							<li
								key={item}
								className="flex items-center gap-3 text-[15px]"
							>
								<svg
									width="16"
									height="16"
									viewBox="0 0 16 16"
									fill="none"
								>
									<circle
										cx="8"
										cy="8"
										r="7.5"
										stroke="#5D2FF0"
										strokeWidth="1"
									/>
									<path
										d="M4.5 8L7 10.5L11.5 5.5"
										stroke="#5D2FF0"
										strokeWidth="1.5"
										strokeLinecap="round"
										strokeLinejoin="round"
									/>
								</svg>
								{item}
							</li>
						))}
					</ul>

					<FormMockup />
				</div>
			</div>
		</section>
	)
}

function FormMockup() {
	return (
		<div
			className="rounded-2xl bg-white p-7"
			style={{
				border: '1px solid var(--border-soft)',
				boxShadow: 'var(--shadow-2)',
			}}
		>
			<div
				className="mb-5 flex items-center justify-between pb-4.5"
				style={{ borderBottom: '1px solid var(--border-soft)' }}
			>
				<div
					className="font-mono text-[13px]"
					style={{ color: 'var(--text-secondary)' }}
				>
					Nouvelle alerte
				</div>
				<div className="flex gap-1.5">
					<span
						className="size-2 rounded-full"
						style={{ background: 'var(--border-soft)' }}
					/>
					<span
						className="size-2 rounded-full"
						style={{ background: 'var(--brand)' }}
					/>
					<span
						className="size-2 rounded-full"
						style={{ background: 'var(--border-soft)' }}
					/>
				</div>
			</div>

			<FormField label="Nom de l'alerte" value="Financement culturel Qc" />

			<div className="mb-4.5">
				<Label>Mots-clés</Label>
				<div
					className="flex flex-wrap items-center gap-1.5 rounded-[10px] bg-white px-3 py-2.5"
					style={{
						border: '1px solid var(--border-soft)',
						minHeight: 48,
					}}
				>
					<Tag>« financement OSBL »</Tag>
					<Tag>culture</Tag>
					<span
						className="font-mono text-[13px]"
						style={{ color: 'var(--text-secondary)' }}
					>
						|
					</span>
					<Tag variant="exclude">SAUF fédéral</Tag>

				</div>
			</div>

			<div className="mb-5">
				<Label>Fréquence</Label>
				<div className="grid grid-cols-3 gap-2" aria-hidden="true">
					{(['Temps réel', 'Quotidien', 'Hebdo'] as const).map((f) => {
						const active = f === 'Quotidien'
						return (
							<div
								key={f}
								className="rounded-[10px] px-2.5 py-2.5 text-center text-[13px] select-none"
								style={{
									border: active
										? '1px solid var(--brand)'
										: '1px solid var(--border-soft)',
									background: active ? 'var(--brand-soft)' : 'white',
									color: active ? 'var(--brand)' : 'var(--ink)',
									fontWeight: active ? 500 : 400,
									cursor: 'default',
								}}
							>
								{f}
							</div>
						)
					})}
				</div>
			</div>

			<div
				className="mb-5 rounded-[10px] p-3.5"
				style={{ background: 'var(--mist)' }}
			>
				<div
					className="mb-2 text-[11px] uppercase tracking-[0.06em]"
					style={{ color: 'var(--text-secondary)' }}
				>
					Aperçu · 7 derniers jours
				</div>
				<div className="mb-3 flex items-baseline gap-2.5">
					<div
						className="font-display"
						style={{ fontSize: 30, fontWeight: 450 }}
					>
						34
					</div>
					<div
						className="text-[13px]"
						style={{ color: 'var(--text-secondary)' }}
					>
						articles captés · pertinence 92%
					</div>
				</div>
				<div className="flex items-end gap-[3px]" style={{ height: 32 }}>
					{[30, 55, 20, 80, 45, 70, 90].map((h, i) => (
						<div
							key={i}
							className="flex-1 rounded-[2px]"
							style={{
								background:
									i === 6 ? 'var(--brand)' : 'rgba(93,47,240,0.3)',
								height: `${h}%`,
							}}
						/>
					))}
				</div>
			</div>

			<div
				aria-hidden="true"
				className="flex w-full items-center justify-center rounded-xl text-[15px] font-medium text-white select-none"
				style={{
					height: 48,
					background: 'var(--brand)',
					boxShadow:
						'0 1px 0 rgba(255,255,255,0.15) inset, 0 8px 24px -8px var(--brand-glow)',
					cursor: 'default',
				}}
			>
				Activer l'alerte
			</div>
		</div>
	)
}

function FormField({ label, value }: { label: string; value: string }) {
	return (
		<div className="mb-4.5">
			<Label>{label}</Label>
			<div
				className="rounded-[10px] px-3.5 py-3 text-[14px]"
				style={{
					border: '1px solid var(--border-soft)',
					color: 'var(--ink)',
				}}
			>
				{value}
			</div>
		</div>
	)
}

function Label({ children }: { children: React.ReactNode }) {
	return (
		<label
			className="mb-1.5 block text-[12px] tracking-[0.02em]"
			style={{ color: 'var(--text-secondary)' }}
		>
			{children}
		</label>
	)
}

function Tag({
	children,
	variant,
}: {
	children: React.ReactNode
	variant?: 'exclude'
}) {
	const exc = variant === 'exclude'
	return (
		<span
			className="rounded-md px-2.5 py-1 font-mono text-[12.5px] font-medium"
			style={{
				background: exc ? 'rgba(209,67,67,0.08)' : 'rgba(93,47,240,0.08)',
				color: exc ? '#D14343' : 'var(--brand)',
				border: exc ? '1px solid rgba(209,67,67,0.2)' : '1px solid rgba(93,47,240,0.2)',
			}}
		>
			{children}
		</span>
	)
}
